import styled, { css } from 'styled-components';
import Link from 'next/link';
import { FlexCenterAligned, FlexibleDiv } from '../../styled/common';
import { Typography } from '../ui/Typography';
import { fontWeight } from '../../styled/constants';

export const FlexedHeader = styled(FlexCenterAligned).attrs({ as: 'header' })`
  background-color: ${({ theme }) => theme.colors.background.primary};
  ${({ isFixedHeader }) =>
    isFixedHeader &&
    css`
      position: sticky;
      width: 100%;
      height: 60px;
      top: 0;
      left: 0;
      z-index: 95;
      background: $colour-white;

      ~ .placeholder-st {
        margin-top: 25px;
      }
    `};
`;

export const Wrapper = styled.div`
  display: flex;
  width: 980px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  position: sticky;
  z-index: 10;
  top: 0;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 15px 10px;

  @media screen and (max-width: ${({ theme }) => theme.desktopBreakpoint}) {
    width: 100%;
    padding: 15px 40px;
  }

  @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 15px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
  }
`;

export const ButtonsGroupContainer = styled(FlexibleDiv)`
  align-items: center;
  gap: 14px;
`;

export const MenuItemsContainer = styled(FlexibleDiv)`
  gap: 15px;
`;

export const MenuItem = styled(Link)`
  text-decoration: none;
`;
const shouldForwardProp = prop => !['isCurrentPage'].includes(prop);

export const MenuItemTypography = styled(Typography).withConfig({
  shouldForwardProp
})`
  ${({ isCurrentPage, theme }) =>
    isCurrentPage &&
    css`
      color: ${theme.colors.systemColors.brand};
      font-weight: ${fontWeight.medium};
    `}

  &:hover {
    color: ${({ theme }) => theme.colors.systemColors.brand};
  }
`;

export const CreateItemIconButton = styled.span`
  margin-right: 5px;
  font-size: 20px;
  font-weight: 400;
  line-height: 0;
`;

export const WebViewButton = styled.button`
  position: absolute;
  right: 0;
  width: 45px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding: 0;

  i {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  svg {
    display: block;
    flex: 1;
  }
`;

export const favoriteIconStyles = {
  display: 'flex',
  width: '30px',
  height: '30px',
  justifyContent: 'center',
  alignItems: 'center'
};
